var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-crabelab-crab';
                    var viewUrl = 'sprite.svg#view-logo-crabelab-crab';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-crabelab-crab#logo-crabelab-crab';
                            viewUrl = 'sprite.svg?logo-crabelab-crab#view-logo-crabelab-crab';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 301 312',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };